<template>
	<div>
		<cube-page title="设置">
			<div slot="content">
				<div class="headerbox" :style="'background-color:'+gcfg.BackgroundColor">
					<div class="avatar">
						<img style="width: 100%;" :src='user.avatar'></img>
					</div>
					<div class="account" :style="'color:'+gcfg.TopTextColor">

						<div class="showname">
							{{ user.nickname }}
						</div>
					</div>
					<!-- <van-button @click="outLog" type="default">退出登录</van-button> -->
				</div>
				<div class="" style="padding: 20px;">
					<van-button @click="outLog" type="default" block>退出登录</van-button>
					
				</div>
			</div>
		</cube-page>
	</div>
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		Toast,Dialog
	} from 'vant';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				gcfg: [],
				user: [],
				third: null,
			}
		},
		created() {
			this.axios_Request()
			this.gcfg = this.$store.getters.getGcfg
		},
		methods: {
			// 退出登录
			outLog() {
				let that = this
				Dialog.confirm({
						title: '温馨提示',
						message: '确定要退出登录吗？',
					})
					.then(() => {
						util.post('/addons/litestore/api.account/logout', {},
							function(result) {
								Dialog.alert({
									title: '温馨提示',
									message: result.msg,
								}).then(() => {
									that.$store.commit('logOut');
									console.log(result);
									window.location.href = result.data;
									/*return false;
									that.reload(); //此处刷新页面*/
								});
								// this.$store.commit('logOut');
							}
						);
					})
					.catch(() => {
						// on cancel
					});
			},
			axios_Request() {
				var url = "/addons/litestore/api.uservue/index"
				let that = this;
				//这里直接调用网络接口
				util.get(url, {},
					function(result) {
						that.user = result.data.user;
						that.third = result['data']['third']
					},
				);
			},
			binding_wx() {
				var urltmp = 'http://' + window.location.host +
					'/addons/litestore/api.uservue/connect?platform=wechat&url=' +
					'http://' + window.location.host + '/addons/litestore/octothorpe/My';

				window.location.href = urltmp
			}
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			}
		}
	}
</script>

<style lang="less">
	.headerbox {
		padding: 15px 0;
		width: 100%;
		/* background: #6d189e; */
		top: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.headerbox .avatar {
		border-radius: 50%;
		overflow: hidden;
		width: 80px;
		height: 80px;
		text-align: center;
		background: #fff;
		border: 2px solid #fff;
		box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
	}

	.headerbox .avatar image {
		width: 100%;
		height: 100%;
	}

	.headerbox .account {
		color: #fff;
		text-align: center;
	}

	.showname {
		font-size: 1.2em;
		padding-bottom: 0.8em;
	}
</style>
